import React from 'react';

import GenericField from './shared/GenericField';
import ItemListInputContainer from './item_list/ItemListInputContainer';

/**
 * Select items from dropdown. Requets suggestions given user input. "item" object: {string id, string name, string detailedName, string link}. detailedName is optional and then used instead of name inin the dropdown.
 * @param {string} [label] Label description for field input.
 * @param {string} [icon] Icon next to input, see ./shared/FormatHelpers.js/getIconClassName for available icons.
 * @param {list<item>} [initialValue] [list<item>] Field value.
 * @param {function} [handleSave] [async list<item>=>{bool success, string message, list<item> value}] Save changes / return error message. If item.id = null then this object should be created with item.id and item.link from item.name and returned in value.
 * @param {async function} [getSuggestions] [async string=>list<item>] Gets suggestions corresponding to user input.
 * @param {bool} [isCreationPermitted] Whether the user can create new objects. See handleSave for how items should be created.
 */
const ItemList = ({ label, icon: iconName, initialValue, handleSave: syncChanges, getSuggestions, isCreationPermitted }) => {
    return (
        <GenericField>
            {label}
            <ItemListInputContainer {...{ iconName, initialValue, syncChanges, getSuggestions, isCreationPermitted }} />
        </GenericField>
    );
};

export default ItemList;
